import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Typography from "@material-ui/core/Typography";
import api from "../../services/api";
import { toast } from "react-toastify";
import { useTheme } from "@material-ui/core/styles";
import { getChartTextColor, getChartGridColor } from "./chartTheme";
import { i18n } from "../../translate/i18n";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const RECEIVED_COLOR = "#009ACC";
const SENT_COLOR = "#2DDD7F";

const buildOptions = (textColor, gridColor) => ({
  responsive: true,
  scales: {
    x: {
      ticks: {
        color: textColor
      },
      grid: {
        color: gridColor
      }
    },
    y: {
      beginAtZero: true,
      ticks: {
        color: textColor
      },
      grid: {
        color: gridColor
      }
    }
  },
  plugins: {
    legend: {
      position: "top",
      display: true,
      labels: {
        color: textColor
      }
    },
    title: {
      display: true,
      text: i18n.t("dashboard.charts.messagesByUser.chartTitle"),
      position: "left",
      color: textColor
    },
    datalabels: {
      display: true,
      anchor: "end",
      align: "end",
      color: textColor,
      font: {
        size: 10,
        weight: "bold"
      },
      formatter: value => {
        const total = Math.trunc(Number(value) || 0);
        return total > 0 ? total : "";
      }
    }
  }
});

export const ChartsMessagesByUser = ({ initialDate, finalDate }) => {
  const [messagesData, setMessagesData] = useState({ data: [] });
  const theme = useTheme();
  const isDark = theme.palette.type === "dark";
  const textColor = getChartTextColor(isDark);
  const gridColor = getChartGridColor(isDark);

  useEffect(() => {
    handleGetMessagesByUser(initialDate, finalDate);
  }, [initialDate, finalDate]);

  const labels = messagesData?.data?.map(item => item.nome) || [];

  const dataCharts = {
    labels,
    datasets: [
      {
        label: i18n.t("dashboard.charts.messagesByUser.received"),
        data: messagesData?.data?.map(item => Number(item.recebidas) || 0) || [],
        backgroundColor: RECEIVED_COLOR
      },
      {
        label: i18n.t("dashboard.charts.messagesByUser.sent"),
        data: messagesData?.data?.map(item => Number(item.enviadas) || 0) || [],
        backgroundColor: SENT_COLOR
      }
    ]
  };

  const handleGetMessagesByUser = async (selectedInitialDate, selectedFinalDate) => {
    try {
      if (!selectedInitialDate || !selectedFinalDate) {
        return;
      }

      const { data } = await api.get("/dashboard/messagesByUser", {
        params: {
          initialDate: selectedInitialDate,
          finalDate: selectedFinalDate
        }
      });

      setMessagesData(data);
    } catch (error) {
      toast.error(i18n.t("dashboard.charts.messagesByUser.loadError"));
    }
  };

  return (
    <>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        {i18n.t("dashboard.charts.messagesByUser.title")}
      </Typography>

      <Bar options={buildOptions(textColor, gridColor)} data={dataCharts} style={{ maxWidth: "100%", maxHeight: "280px" }} />
    </>
  );
};
